import { useEffect } from 'react';
import { Box, Chip, Typography, useMediaQuery, useTheme } from '@mui/material';
import { DataGrid, type GridColDef } from '@mui/x-data-grid';
import { useBeneficiosStore } from '../store/beneficiosStore';

export default function VacacionesPorVencerTab() {
  const { alertasVencimiento, loading, loadAlertasVencimiento } = useBeneficiosStore();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    loadAlertasVencimiento(90);
  }, [loadAlertasVencimiento]);

  const urgenciaColor = (dias: number): 'error' | 'warning' | 'info' => {
    if (dias <= 30) return 'error';
    if (dias <= 60) return 'warning';
    return 'info';
  };

  const columns: GridColDef[] = [
    { field: 'nombreTrabajador', headerName: 'Trabajador', flex: 1, minWidth: isMobile ? 120 : 200 },
    ...(!isMobile ? [
      { field: 'periodoLabel', headerName: 'Periodo', width: 220 },
    ] : []),
    { field: 'diasPendientes', headerName: isMobile ? 'Pend.' : 'Días Pend.', width: isMobile ? 70 : 100, type: 'number' },
    ...(!isMobile ? [
      { field: 'fechaVencimiento', headerName: 'Vencimiento', width: 120,
        valueFormatter: (value: string) => value ? new Date(value).toLocaleDateString('es-PE') : '' },
    ] : []),
    { field: 'diasParaVencer', headerName: isMobile ? 'Vence' : 'Días p/ Vencer', width: isMobile ? 90 : 130,
      renderCell: (params) => (
        <Chip
          label={`${params.value}d`}
          size="small"
          color={urgenciaColor(params.value as number)}
        />
      ),
    },
  ];

  return (
    <Box>
      <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 1 }}>
        {isMobile ? 'Periodos próximos a vencer (90 días)' : 'Periodos vacacionales con saldo pendiente próximos a vencer (90 días)'}
      </Typography>
      <DataGrid
        rows={alertasVencimiento}
        columns={columns}
        getRowId={(row) => row.idVacacion}
        autoHeight
        density="compact"
        loading={loading}
        disableRowSelectionOnClick
        pageSizeOptions={[10, 25]}
        initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
      />
    </Box>
  );
}
